import {
  usersListTranslation,
  UsersListTranslation,
} from '@/assets/locales/views/users/list/usersList.translation.pl.ts';

export type UsersTranslation = {
  list: UsersListTranslation;
};

export const usersTranslation: UsersTranslation = {
  list: usersListTranslation,
};
